import { Fragment, jsx } from "react/jsx-runtime";
import { FloatingOverlay, FloatingPortal } from "@floating-ui/react";
import { Theme, useIsTouchDevice, useThemeName } from "@tamagui/core";
import { Dismissable } from "@tamagui/dismissable";
import { FocusScope } from "@tamagui/focus-scope";
import { useSelectContext } from "./context";
import { useShowSelectSheet } from "./useSelectBreakpointActive";
const CONTENT_NAME = "SelectContent";
const SelectContent = ({
  children,
  __scopeSelect,
  zIndex = 1e3,
  ...focusScopeProps
}) => {
  const context = useSelectContext(CONTENT_NAME, __scopeSelect);
  const themeName = useThemeName();
  const showSheet = useShowSelectSheet(context);
  const contents = /* @__PURE__ */ jsx(Theme, { forceClassName: true, name: themeName, children });
  const touch = useIsTouchDevice();
  if (context.shouldRenderWebNative) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  if (showSheet) {
    if (!context.open) {
      return null;
    }
    return /* @__PURE__ */ jsx(Fragment, { children: contents });
  }
  return /* @__PURE__ */ jsx(FloatingPortal, { children: context.open ? /* @__PURE__ */ jsx(FloatingOverlay, { style: { zIndex }, lockScroll: !touch, children: /* @__PURE__ */ jsx(FocusScope, { loop: true, trapped: true, ...focusScopeProps, children: /* @__PURE__ */ jsx(Dismissable, { children: contents }) }) }) : /* @__PURE__ */ jsx("div", { style: { display: "none" }, children: contents }) });
};
export {
  SelectContent
};
//# sourceMappingURL=SelectContent.js.map
